import React from 'react'
import WebBeacon from 'components/common/webBeacon'
import { SubscriberProvider } from 'providers/SubscriberProvider'
import SubscriberForm from 'components/subscription/subscriberForm'

function SubscriberPage() {
  const webBeaconSrc = process.env.REACT_APP_WEB_BEACON_IMAGE

  return (
    <SubscriberProvider initData={{}}>
      <WebBeacon src={webBeaconSrc} id='id-web-beacon' />
      <SubscriberForm />
    </SubscriberProvider>
  )
}

export default SubscriberPage
